// extracted by mini-css-extract-plugin
export default {"transports":"servicelist_transports__R7PZj","heading":"servicelist_heading__UrqGv","transport-cards":"servicelist_transport-cards__6ioPf"};